// Mock data per Isoliamo

export const servizi = [
  {
    id: 1,
    title: "Isolamento Sottotetti",
    icon: "home",
    description: "Isolamento termico per sottotetti non abitati con fibra di cellulosa. Riduce la dispersione termica fino al 30%.",
    features: [
      "Riduzione dispersione termica fino al 30%",
      "Risparmio energetico immediato",
      "Materiale ecologico certificato",
      "Installazione rapida e pulita"
    ]
  },
  {
    id: 2,
    title: "Isolamento Intercapedini",
    icon: "walls",
    description: "Isolamento delle intercapedini murarie con insufflaggio di fibra di cellulosa. Elimina ponti termici.",
    features: [
      "Eliminazione ponti termici",
      "Risparmio fino al 40% su riscaldamento",
      "Maggior comfort abitativo",
      "Aumento valore immobile"
    ]
  }
];

export const vantaggi = [
  {
    id: 1,
    icon: "leaf",
    title: "100% Ecologico",
    description: "Fibra di cellulosa da carta riciclata, materiale naturale e sostenibile"
  },
  {
    id: 2,
    icon: "shield-check",
    title: "Certificato e Sicuro",
    description: "Certificazioni CE, ignifugo classe B-s2-d0, non tossico"
  },
  {
    id: 3,
    icon: "zap",
    title: "Risparmio Energetico",
    description: "Riduci i costi di riscaldamento e raffrescamento fino al 40%"
  },
  {
    id: 4,
    icon: "clock",
    title: "Installazione Rapida",
    description: "Posa in opera veloce, senza demolizioni né sporco"
  },
  {
    id: 5,
    icon: "award",
    title: "Detrazioni Fiscali",
    description: "Bonus 50% prima casa, 36% altre abitazioni - Pratica ENEA inclusa"
  },
  {
    id: 6,
    icon: "thermometer",
    title: "Comfort 365 Giorni",
    description: "Caldo d'inverno, fresco d'estate, sempre la temperatura ideale"
  }
];

export const primaDopoData = [
  {
    id: 1,
    categoria: "Temperatura",
    prima: "Escursioni di 10-15°C",
    dopo: "Temperatura stabile ±2°C",
    miglioramento: "+85%"
  },
  {
    id: 2,
    categoria: "Consumo Energetico",
    prima: "€2.000/anno riscaldamento",
    dopo: "€1.200/anno risparmio",
    miglioramento: "-40%"
  },
  {
    id: 3,
    categoria: "Classe Energetica",
    prima: "Classe E/F",
    dopo: "Classe B/C",
    miglioramento: "+3 classi"
  },
  {
    id: 4,
    categoria: "Comfort Abitativo",
    prima: "Discomfort termico",
    dopo: "Benessere ottimale",
    miglioramento: "+90%"
  }
];

export const certificazioni = [
  {
    id: 1,
    nome: "Certificazione CE",
    descrizione: "Conformità normativa europea"
  },
  {
    id: 2,
    nome: "Classe Ignifuga B-s2-d0",
    descrizione: "Massima sicurezza antincendio"
  },
  {
    id: 3,
    nome: "CAM - Criteri Ambientali Minimi",
    descrizione: "Conforme ai criteri ambientali"
  },
  {
    id: 4,
    nome: "Bonus Ristrutturazione",
    descrizione: "50% prima casa, 36% altre abitazioni"
  }
];

export const processoLavoro = [
  {
    step: 1,
    title: "Sopralluogo Gratuito",
    description: "Analisi della tua casa e valutazione personalizzata",
    icon: "search"
  },
  {
    step: 2,
    title: "Preventivo Dettagliato",
    description: "Calcolo preciso con stima risparmio energetico",
    icon: "file-text"
  },
  {
    step: 3,
    title: "Installazione Rapida",
    description: "Posa professionale con minimo disturbo",
    icon: "hammer"
  },
  {
    step: 4,
    title: "Certificazione e Garanzia",
    description: "Documentazione completa e garanzia decennale",
    icon: "check-circle"
  }
];

export const testimonianze = [
  {
    id: 1,
    nome: "Marco R.",
    citta: "Milano",
    rating: 5,
    testo: "Dopo l'isolamento del sottotetto la bolletta si è dimezzata. Casa calda d'inverno e fresca d'estate. Consigliatissimo!",
    servizio: "Sottotetto 120mq"
  },
  {
    id: 2,
    nome: "Laura B.",
    citta: "Brescia",
    rating: 5,
    testo: "Professionali e veloci. In un giorno hanno isolato le intercapedini senza sporcare. Risultato eccellente!",
    servizio: "Intercapedini 80mq"
  },
  {
    id: 3,
    nome: "Giuseppe M.",
    citta: "Bergamo",
    rating: 5,
    testo: "Scettici all'inizio, ora siamo entusiasti. Il comfort è migliorato tantissimo e risparmio 600€ all'anno.",
    servizio: "Sottotetto + Intercapedini"
  }
];

export const faqData = [
  {
    id: 1,
    domanda: "Quanto tempo richiede l'installazione?",
    risposta: "L'installazione è rapida: per un sottotetto di 100mq servono 1-2 giorni, per le intercapedini anche solo 1 giorno. Non serve svuotare casa."
  },
  {
    id: 2,
    domanda: "Quanto posso risparmiare con l'isolamento?",
    risposta: "Il risparmio medio è del 30-40% sui costi di riscaldamento e raffrescamento. Su una bolletta di €2.000/anno, risparmi €600-800 ogni anno, più la detrazione fiscale del 50% (prima casa) o 36% (altre abitazioni)."
  },
  {
    id: 3,
    domanda: "La fibra di cellulosa è sicura?",
    risposta: "Assolutamente sì. È certificata ignifuga classe B-s2-d0, non tossica, antifungina e anallergica. Materiale naturale da carta riciclata."
  },
  {
    id: 4,
    domanda: "Posso accedere alle detrazioni fiscali?",
    risposta: "Sì! Bonus ristrutturazione 50% per prima casa, 36% per altre abitazioni. Ci occupiamo noi della pratica ENEA e di tutta la documentazione necessaria."
  },
  {
    id: 5,
    domanda: "L'isolamento vale anche per il caldo estivo?",
    risposta: "Sì! La fibra di cellulosa ha un'ottima inerzia termica: d'estate tiene il fresco dentro e il caldo fuori, riducendo l'uso del condizionatore."
  },
  {
    id: 6,
    domanda: "Che garanzia offrite?",
    risposta: "Offriamo garanzia Isoliamo sui materiali e sulla posa in opera. Siamo un'azienda certificata con oltre 15 anni di esperienza."
  },
  {
    id: 7,
    domanda: "Chi si occupa della pratica ENEA?",
    risposta: "Ci pensiamo noi! Gestiamo completamente la pratica ENEA e tutta la documentazione necessaria per ottenere le detrazioni fiscali. Tu non devi fare nulla."
  }
];

export const tipiImmobile = [
  "Appartamento",
  "Villa singola",
  "Villa bifamiliare",
  "Casa a schiera",
  "Rustico",
  "Altro"
];

export const tipiIntervento = [
  "Sottotetto",
  "Pareti (intercapedini)",
  "Sottotetto + Pareti"
];

export const tipologiaImmobile = [
  "Prima casa",
  "Seconda casa / Investimento"
];
